var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff6A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100.03 142.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#233135;}.cls-3{fill:#495e68;}.cls-4{fill:#5c7581;}.cls-5{fill:#4a5f6a;}.cls-6{fill:#0b4f7d;}.cls-7{fill:#1f69ad;}.cls-8{fill:#304249;}.cls-9{fill:#f5ebf4;}.cls-10{fill:#e8dae8;}.cls-11{fill:#f3b892;}.cls-12{fill:#51290a;}.cls-13{fill:#8a8d9b;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "WomanOnChair_01a",
    "data-name": "WomanOnChair_01a",
    viewBox: "0 0 100.03 142.34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.24,104.47l-.47,0c-1.49-.08-6.15-.31-8-.21-2.17.12-3.25,1.56-1.56,2.76a53.69,53.69,0,0,0,6.17,3.42c3.06,1.47,6.26,2.69,7.24,2,2.48-1.61,0-8.47,0-8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.66,103.74S27,74.57,26.74,71.12s1.08-7.22,5.42-7.83A22.27,22.27,0,0,1,45,65.58c4.21,2,27,10.8,28.77,13.24s.24,9.64-3,10.6S39.62,76.78,39.62,76.78s-1.48,24-1.57,26.36-.6,4-4,4S29.27,106.27,28.66,103.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.56,118.54a1.19,1.19,0,0,0-.6-1l-1.7-1a3.52,3.52,0,0,0-2.85-.3L26.22,134.16a1.19,1.19,0,0,0-.83,1.24c0,.37,0,1.86,0,2.35a1.17,1.17,0,0,0,.6,1l1.54.89a3.85,3.85,0,0,0,3.16.33l55-17.88a1.19,1.19,0,0,0,.83-1.18C86.55,120.54,86.56,119,86.56,118.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.54,138.22a1.12,1.12,0,0,0-.58-1L38.4,114.36a3.3,3.3,0,0,0-2.69-.29l-1.52.49a1.15,1.15,0,0,0-.79,1.12v2.39a1.12,1.12,0,0,0,.57,1l39.4,22.74a3.71,3.71,0,0,0,3,.32l1.32-.43a1.14,1.14,0,0,0,.8-1.1C78.54,140.24,78.53,138.67,78.54,138.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26,136.35l1.54.89a3.93,3.93,0,0,0,3.16.33l55-17.88A1.21,1.21,0,0,0,86,117.5l-1.7-1a3.52,3.52,0,0,0-2.85-.3L26.22,134.16A1.21,1.21,0,0,0,26,136.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.74,139.29l-1.32.43a3.74,3.74,0,0,1-3-.32L34,116.66a1.16,1.16,0,0,1,.22-2.1l1.52-.49a3.3,3.3,0,0,1,2.69.29L78,137.2A1.15,1.15,0,0,1,77.74,139.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.24,117.37c-.06-.55-.67-1.09-1.77-1.43a7.57,7.57,0,0,0-5.6.45,1.28,1.28,0,0,0-.69,1h0v0h0l0,9.68c.06.55.67,1.09,1.77,1.43a7.57,7.57,0,0,0,5.6-.45,1.28,1.28,0,0,0,.69-1h0v0h0v-9.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 55.22,
    cy: 117.41,
    rx: 1.79,
    ry: 4.04,
    transform: "translate(-62.78 171.36) rotate(-89.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.63,102.2c0-.33-.4-.65-1.06-.86a4.56,4.56,0,0,0-3.36.27.74.74,0,0,0-.41.59h0v14.58c0,.33.4.65,1.06.85a4.52,4.52,0,0,0,3.36-.26.74.74,0,0,0,.41-.59h0V102.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88.92,91.83a3.21,3.21,0,0,0-1.64-2.76L63.6,75.4a12.79,12.79,0,0,0-10.36-1.09L22,84.46a3,3,0,0,0-2.08,3c0,.89,0,3.9,0,4.85a3,3,0,0,0,1.51,2.58l24,13.84a13.46,13.46,0,0,0,10.88,1.14L86.66,100a3.25,3.25,0,0,0,2.26-3.11C88.93,95.94,88.94,92.77,88.92,91.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.4,103.77l-24-13.83A3,3,0,0,1,22,84.46L53.24,74.31A12.79,12.79,0,0,1,63.6,75.4L87.28,89.07a3.28,3.28,0,0,1-.62,6l-30.38,9.87A13.42,13.42,0,0,1,45.4,103.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.55,113.82c-7.72,0-12.16-.36-12.4,1s-.84,3,4.46,4.7S18.38,122.64,20,122s.72-8.07.72-8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.08,77.38s-18.16-5-22.8-6.65-11.86-.58-12.68,5.75-.13,33.25-.25,35.66,2.07,3.44,4,4,7.58,1.08,7-2.77-.14-26.57-.14-26.57c11.44,8.67,24.44,15.65,30.22,14.69s17.94-4.7,20.83-7.11,4.21-11.67,4.33-15.77S47.08,77.38,47.08,77.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.7,28.13c4.36-3.17,9.91.33,11,4.06s3.54,21.94,2.39,23.66-14.56,2.41-14.56,2.41l-.59-19.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41,37.47c4.8-4.8,8.48-6.09,15.65-8.31s12.05-2.47,14-1.63,4.93,4.27,5.16,8.13,1.75,14.37.47,23.18-2.06,21.7-2.65,24.78-9.46,7.17-17,6.93-13.26-4.14-14.06-7.13c-1.39-5.16-1.59-19.3-1.75-24S38.26,40.24,41,37.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64,24.83,64.38,28l.36,2.65a24.55,24.55,0,0,1-6,1.08A13.52,13.52,0,0,1,52.58,30l.24-4s-3-.55-3.73-1.68-.62-9.7-.12-13.25,2.17-9.63,10.11-9,10.72,3.25,10,8.79S67.75,22.78,64,24.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M54.1,16.87l-2.07-1c-5.66-2-7.07-9.48-1.42-13.42S64.82,0,68.67,3s3.63,8.68,2.41,13.55-3.4,8.25-9.54,8.65S57.48,22,57.48,22c2.52-1.34,2.58-5.74,1.08-6.62A3.2,3.2,0,0,0,54.1,16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M21.11,55.87,15.7,53.34c-.85-1.2-3.13-5.89-4.34-6.14A9.36,9.36,0,0,0,5.7,48.89C4.54,50,4.38,50.94,5,51.78a49.12,49.12,0,0,0,5.66,5.3c1.08.72,10.51,6.46,10.51,6.46L25,57.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M48.61,31.57l3-3.85s5.87,3.54,10.11,2.4S64.38,28,64.38,28l2.77,2.4c-2.65,4-7.14,3.94-10.84,2.89S48.61,31.57,48.61,31.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M45.84,35.9c-5.66-1-6.67,3.61-7.68,6.7s-5,16.24-5,16.24c-4.46-1-10-3.33-11.72-3.81a3.46,3.46,0,0,0-4.21,2c-.84,1.8-1.56,4.21,0,5.17s10.15,6.22,14.36,7.43,8.22,3,10.35-1.33S49.44,52.7,50.88,46.8,50.55,37.48,45.84,35.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.56,48a3.55,3.55,0,0,0-3.19-.48L58.66,58.15a8.21,8.21,0,0,0-5.38,5.68L48.06,83.48a3,3,0,0,0,1,3.11c.76.64,3.19,2.68,3.94,3.33a3,3,0,0,0,2.92.58L90,79.43a7.16,7.16,0,0,0,4.69-4.94L99.9,55.18a3.54,3.54,0,0,0-1.15-3.68C98,50.9,95.41,48.59,94.56,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.24,67.17,52,86.82A3,3,0,0,0,55.9,90.5L90,79.43a7.16,7.16,0,0,0,4.69-4.94L99.9,55.18a3.59,3.59,0,0,0-4.57-4.35L62.62,61.49A8.19,8.19,0,0,0,57.24,67.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "80.21 68.02 74.82 69.77 77.51 71.33 82.9 69.58 80.21 68.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "74.82 69.77 69.43 107.97 72.13 109.53 77.51 71.33 74.82 69.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.51 71.33 72.13 109.53 77.51 107.78 82.9 69.58 77.51 71.33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 71.35,
    cy: 6.73,
    rx: 6.24,
    ry: 6.14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 100.03,
    height: 142.34,
    xlinkHref: "#WomanOnChair_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff6A);
export default __webpack_public_path__ + "static/media/staff-6-a.1f1bfc9524708ed503eb3de0301ea795.svg";
export { ForwardRef as ReactComponent };